import React from 'react';
import { Form, Input, DatePicker, Col, Row } from 'antd';
import { FormInstance } from 'antd/lib/form';
import FormInput from 'components/FormInput';
import Address from 'components/theme_components/ThirdParty/address';
import AddressSFS from 'components/theme_components/ThirdParty/address/AddresseSFS';

export type AddresseProps = {
  form: FormInstance;
  required: boolean;
};
const Addresse = ({ form, required }: AddresseProps) => {
  return (
    <Row gutter={16}>
      <FormInput col xs={24} md={24} style={{ marginBottom: '30px' }} name="tpmainadrstreet1" comcode="tpmainadrstreet1" rules={[{ required: required }]} />
      <FormInput col xs={24} md={24} style={{ marginBottom: '30px', }} name="tpmainadrstreet2" comcode='tpmainadrstreet2TP' />
      <FormInput col xs={24} md={24} style={{ marginBottom: '30px', }} name="tpmainadrstreet3" comcode='tpmainadrstreet3TP' />

      <AddressSFS
        form={form}
        codePostalField="tpmainadrzipcode"
        paysField="tpmainadrcountry"
        regionField="tpmainadrregion"
        villeField="tpmainadrcity"
        comcodecodePostalField="tpmainadrzipcodeTP"
        comcodepaysField="tpmainadrcountryTP"
        comcoderegionField="tpmainadrregionTP"
        comcodevilleField="tpmainadrcityTP"
        colU={24}
        hideRegionGlobal
        hideRegion
        Colw={(localStorage.getItem('lancode') === 'FR') ? { span: 10 } : { span: 4 }}
        spanCountry={6}
        spanZip={6}
        spanCity={17}
        cityRequired={required}
        zipcodeRequired={required}
        countryRequired={required}
      />
    </Row>
  );
};

export default Addresse;
